import * as React from "react";
import Section from "../Layout/Section";
import * as styles from "./tariffs.module.css";
import TariffCard from "../Tariffs/Card";
import TemplateString from "../Common/TemplateString";

const SolutionTariffs = ({tariffs}) => {
    if (!tariffs) {
        return null;
    }

    const sortedTariffs = tariffs.tariffs.sort(({price: aPrice}, {price: bPrice}) => aPrice - bPrice);

    return (
        <Section title={<TemplateString template={tariffs.title} />}>
            <div className={styles.tariffs__list}>
                {sortedTariffs.map((tariff) => {
                    return <TariffCard key={tariff.id} tariff={tariff} />;
                })}
            </div>
        </Section>
    );
};

export default SolutionTariffs;
